<template>
    <section class="comp_search">
        <div class="comp_scroller">
            <div class="comp_content">
                <form class="wrp_comp_header mod--row mod--row-flex mod--row-middle">
                    <div class="col mod--flex-grow">
                        <div class="part_ui_input"><input type="search"/></div>
                    </div>
                    <div class="col">
                        <button type="submit"><span class="icon icon--search"></span></button>
                    </div>
                </form>
                <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)">
                    <div class="elm_item" v-for="item in results"></div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'search',
    data() {
        return {
            results: []
        }
    },
    mounted() {

    },
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/search.vue